<template>
  <vxe-modal v-model="visible" :title="$t('button.waveStatus')" width="70%">
    <vxe-card>
      <template #title>
        <vxe-input v-model="query['wave']" clearable placeholder="business.label.wave" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['order.no']" clearable placeholder="business.label.orderNo" @clear="refresh" @keydown.native.enter="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
      </template>
      <vxe-table
        ref="table"
        :column-config="{resizable:true}"
        :data="data"
        :export-config="{}"
        :height="height"
        :keyboard-config="{isArrow:true}"
        :loading="loading"
        :row-config="{isCurrent: true, isHover: true}"
        :scroll-x="{enabled: true}"
        align="center"
        border
        round
        show-header-overflow
        show-overflow
        size="mini"
        stripe>
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="dispatch.wave" title="business.label.wave" width="100"/>
        <vxe-column field="order.no" title="business.label.orderNo"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:orderStatus}" field="order.orderStatus" title="business.label.orderStatus" width="100"/>
        <vxe-column field="owner.name" title="business.label.ownerName" width="120"/>
      </vxe-table>
    </vxe-card>
  </vxe-modal>
</template>

<script>
import Vue from 'vue'
import { findAll, findEnum } from '@/api/Api'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
  data() {
    return {
      visible: false,
      loading: false,
      data: [],
      orderStatus: [],
      query: {
        'wave': '',
        'order.no': ''
      },
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.6)
    }
  },
  created() {
    findEnum('OrderStatus').then(res => {
      if (res.success) {
        this.orderStatus = res.result.map(item => {
          return { label: item.name, value: item.ordinal }
        })
      }
    })
  },
  methods: {
    open() {
      this.visible = true
      this.refresh()
    },
    fetch() {
      this.loading = true
      findAll('dispatchWaveStatusFactory', this.query).then(res => {
        if (res.success) {
          this.data = Object.values(res.result.reduce((acc, item) => {
            const key = `${item.dispatch.wave}_${item.order.orderStatus}_${item.owner.name}`
            if (!acc[key]) {
              acc[key] = {
                'dispatch.wave': item.dispatch.wave,
                'order.orderStatus': item.order.orderStatus,
                'owner.name': item.owner.name,
                'order.no': [item.order.no]
              }
            } else {
              acc[key]['order.no'].push(item.order.no)
            }
            return acc
          }, {})).map(item => ({
            ...item,
            'order.no': item['order.no'].join(',')
          }))
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = {
        'wave': '',
        'order.no': ''
      }
      this.refresh()
    }
  }
}
</script>